<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/55kFD4/tc-custom/9781504045063.jpg?1737334804288" alt="This image is the cover for the book King Devil"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">King Devil
      </h1>
      <p class="bookDescription body article font2">
        <b>A historical mystery set in early twentieth-century New England from the acclaimed author of the Peter Shandy series.</b><br/><br/> Upon graduating from an academy for respectable young ladies, Lavinia Tabard heads to the New England countryside and her rich cousin Zilpha’s summer cottage with the low expectations of a charity case. Lavinia intends to endure Zilpha’s saccharine sweetness and her “companion” Tetsy’s bullying ways only until she can plan an escape that doesn’t involve marriage.<br/>  <br/> A welcome distraction comes when, as she works on a grave rubbing at the local cemetery, Lavinia notices something strange about the dates on the stone. Her questions lead to the doorsteps of several interesting neighbors, including a self-made young architect with a temper as fiery as his red hair. Hayward Clinton and his partner have an office on Zilpha’s property, an awkward situation that won’t change until the mysterious disappearance of the business’s original owner is solved. It’s a case too curious for Lavinia to resist—but someone will stop at nothing to ensure that she does.<br/>  <br/><i>King Devil</i> is an entertaining tale of suspense from the acclaimed author of the Peter Shandy Mysteries, as well as the Boston-set Sarah Kelling and Max Bittersohn series.<br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlotte MacLeod
      </h2>
      
      <p class="authorDescription body article">Charlotte MacLeod (1922&ndash;2005) was an international&#160;bestselling author of cozy mysteries. Born in Canada, she moved to Boston as a child&#160;and lived in New England most of her life. After graduating from college, she made a career in advertising, writing copy for the Stop &amp; Shop Supermarket Company before moving on to Boston firm N. H. Miller &amp; Co., where she rose to the rank of vice president. In her spare time, MacLeod wrote short stories, and in 1964 published her first novel, a children&rsquo;s book called <I>Mystery of the White Knight.</I><I>&#160;</I>In <I>Rest You Merry</I> (1978), MacLeod introduced Professor Peter Shandy, a horticulturist and amateur sleuth whose adventures she would chronicle for two decades. <I>The Family Vault </I>(1979) marked the first appearance of her other best-known characters: the husband and wife sleuthing team Sarah Kelling and Max Bittersohn, whom she followed until her last novel, <I>The Balloon Man</I>, in 1998.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?752701e0